import { render, staticRenderFns } from "./Child2.vue?vue&type=template&id=74958906&"
import script from "./Child2.vue?vue&type=script&lang=ts&"
export * from "./Child2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports